import { ReactElement, useContext, useEffect, useState } from 'react'
import { UserContext } from '../../context/UserContext'
import UserAction from '../../context/action/UserAction'
import { StudentsUI, getStudentsTreeTable } from '../../model/StudentsUI'
import { Collapse, Paper } from '@mui/material'
import DevelopusTreeTable from '../../../../common/ui/treetable/DevelopusTreeTable'
import { UUID } from 'crypto'
import { t } from 'i18next'
import DevelopusButton from '../../../../common/ui/button/DevelopusButton'
import { StudentUI } from '../../model/StudentUI'
import StudentEdit from './edit/StudentEdit'
import StudentCreate from './create/StudentCreate'
import DevelopusSnackbarActions from '../../../../common/ui/snackbar/DevelopusSnackbarActions'
import DevelopusSnackbarContext from '../../../../common/ui/snackbar/DevelopusSnackbarContext'

const Students = (): ReactElement => {
  const snackbarContext = useContext(DevelopusSnackbarContext)
  const snackbarActions = new DevelopusSnackbarActions(snackbarContext)

  const context = useContext(UserContext)
  const action = new UserAction(context)

  const [students, setStudents] = useState<StudentsUI | undefined>(undefined)
  const [currentStudent, setCurrentStudent] = useState<StudentUI | undefined>(
    undefined,
  )

  useEffect(() => {
    action.setStudents()
  }, [action.getUsers()])

  useEffect(() => {
    setStudents(action.getStudents().toStudentsUI())
  }, [action.getStudents()])

  useEffect(() => {
    setCurrentStudent(action.getCurrentStudent()?.toStudentUI())
  }, [action.getCurrentStudent()])

  const handleCreateStudent = () => {
    setCurrentStudent(undefined)
    action.toggleEditMode()
  }

  const handleEdit = (id?: UUID) => {
    if (id !== undefined) {
      action.toggleEditMode()
      action.setCurrentStudentById(id)
    }
  }

  const handleRemove = async (id?: UUID) => {
    if (id !== undefined) {
      await action.removeStudent(id)

      snackbarActions.showSnackbar('Student removed')
      action.refreshStudentsPage()
    }
  }

  return (
    <>
      <h1> {t('users.students.title')} </h1>
      {students !== undefined && (
        <>
          {!action.isEditMode() && (
            <div
              style={{
                textAlign: 'right',
                margin: '25px',
              }}
            >
              <DevelopusButton
                handleClick={handleCreateStudent}
                text={t('users.common.createStudent')}
              />
            </div>
          )}
          <Paper elevation={10} sx={{ minHeight: '500px', padding: '10px' }}>
            <Collapse in={!action.isEditMode()}>
              {students !== undefined && (
                <DevelopusTreeTable
                  table={getStudentsTreeTable(students)}
                  collapsed={false}
                  handleEdit={handleEdit}
                  handleRemove={handleRemove}
                  refreshPage={action.isEditMode()}
                />
              )}
            </Collapse>
            <Collapse in={action.isEditMode()}>
              {action.isEditMode() && currentStudent !== undefined && (
                <StudentEdit />
              )}
              {action.isEditMode() && currentStudent === undefined && (
                <StudentCreate />
              )}
            </Collapse>
          </Paper>
        </>
      )}
    </>
  )
}

export default Students
